/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 18.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { FormLabel, FormControl, FormGroup } from 'external/react-bootstrap';
import { ValidationMessage } from 'plugin/liferay-widgets-react-web';

class MapConfigEditLayerForm extends React.Component {

    constructor(props) {
        super(props);

        if (this.props.formData.isNew) {
            this.state = {
                title: '',
                description: '',
                config: ''
            };
        } else {
            this.state = {
                ...props.formData.layerSet
            };
        }
    }

    componentDidMount() {
        const { formData } = this.props;
        return this.props.onChange(formData, this.validate(formData));
    }

    validate(formData) {
        let titleValid, descriptionValid, configValid;

        if (!(formData.title && formData.title.length > 0)) {
            titleValid = 'Bitte Titel eingeben';
        }

        if ((formData.title && formData.title.length > 0 && !/\S/.test(formData.title))) {
            titleValid = 'Titel darf nicht mit einem leerzeichen starten!';
        }

        if ((formData.title && formData.title.length > 0) && !(formData.title.length <= 75)) {
            titleValid = 'Titel zu lang. Maximal 75 Zeichen.';
        }

        if ((formData.description && formData.description.length > 0 && !/\S/.test(formData.description))) {
            descriptionValid = 'Beschreibung darf nicht mit einem leerzeichen starten!';
        }


        if ((formData.description && formData.description.length > 0) && !(formData.description.length <= 3999)) {
            descriptionValid = 'Beschreibung zu lang. Maximal 75 Zeichen.';
        }


        return {
            title: titleValid,
            description: descriptionValid,
            config: configValid,
        };
    }

    onChange(field, e) {
        let formData = this.props.formData,
            item = formData.item || formData;

        let newData = {
            ...item,
            [ field ]: e.target.value
        };

        return this.props.onChange(newData, this.validate(newData));
    }

    render() {
        const { formValidation, formData } = this.props;
        const isNew = this.props.formData.isNew;

        return (
            <div className="p-3">
                {(isNew && <h1>Gruppierung hinzufügen</h1>) || <h1>Gruppierung bearbeiten</h1>}

                <p>Bitte geben Sie den Titel und die Beschreibung der {isNew && <span>neuen</span>} Gruppierung ein.</p>

                <FormGroup>
                    <FormLabel lg={2} md={3} sm={12} xs={12}>Titel</FormLabel>
                    <FormControl lg={10} md={9} sm={12} xs={12}
                                 type="text"
                                 placeholder="Titel"
                                 value={formData.title}
                                 onChange={this.onChange.bind(this, 'title')}/>
                    <ValidationMessage formValidation={formValidation} propName="title"/>
                </FormGroup>

                <FormGroup>
                    <FormLabel lg={2} md={3} sm={12} xs={12}>Beschreibung</FormLabel>
                    <FormControl lg={10} md={9} sm={12} xs={12}
                                 type="text"
                                 placeholder="Beschreibung"
                                 value={formData.description}
                                 onChange={this.onChange.bind(this, 'description')}/>
                    <ValidationMessage formValidation={formValidation} propName="description"/>
                </FormGroup>

                <FormGroup>
                    <FormLabel lg={2} md={3} sm={12} xs={12}>Kofiguration</FormLabel>
                    <FormControl lg={10} md={9} sm={12} xs={12}
                                 type="text"
                                 placeholder="Kofiguration"
                                 value={formData.config}
                                 onChange={this.onChange.bind(this, 'config')}/>
                    <ValidationMessage formValidation={formValidation} propName="config"/>
                </FormGroup>
            </div>
        );
    }
}

MapConfigEditLayerForm.propTypes = {
    formData: PropTypes.object,
    formValidation: PropTypes.object,
    onChange: PropTypes.func.isRequired
};

export default MapConfigEditLayerForm;



// WEBPACK FOOTER //
// ./js/components/MapConfigEditLayerForm.jsx